import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DeactivationBlockersResult } from '../../models/user-deactivation-blocker.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) { }

  async getUsers(page: number, items: number, name?: string, department?: string, rol?: string, isActive?: boolean) {
    let paramsString = '';
    
    if (name && name !== '') {
      paramsString += `&name=${encodeURIComponent(name)}`;
    }
    if (department && department !== '') {
      paramsString += `&department=${encodeURIComponent(department)}`;
    }
    if (rol && rol !== '') {
      paramsString += `&rol=${rol}`;
    }
    if (isActive !== undefined) {
      paramsString += `&isActive=${isActive}`;
    }

    return await lastValueFrom<any>(
      this.http.get(`${environment.apiUrl}/users?page=${page}&items=${items}${paramsString}`)
    );
  }

  async getUserById(id: number) {
    return await lastValueFrom<any>(
      this.http.get(`${environment.apiUrl}/users/${id}`)
    );
  }

  async createOrUpdate(user: any) {
    return await lastValueFrom<any>(
      this.http.post(`${environment.apiUrl}/users`, user)
    );
  }

  async toggleUserStatus(id: number, isActive: boolean) {
    return await lastValueFrom<any>(
      this.http.patch(`${environment.apiUrl}/users/${id}/toggle-status`, { isActive })
    );
  }

  async getUsersListNames() {
    return await lastValueFrom<any>(
      this.http.get(`${environment.apiUrl}/users/list-names`)
    );
  }

  async changePassword(id: number, password: string, confirmPassword: string) {
    return await lastValueFrom<any>(
      this.http.patch(`${environment.apiUrl}/users/${id}/change-password`, { password, confirmPassword })
    );
  }

  async getDeactivationBlockers(id: number): Promise<DeactivationBlockersResult> {
    return await lastValueFrom(
      this.http.get<DeactivationBlockersResult>(`${environment.apiUrl}/users/${id}/deactivation-blockers`)
    );
  }
}
